export default __webpack_public_path__ + "3d03841cdca7eb0604d1283c50b25f01.svg";